/* tslint:disable:no-console */
import Backbone from 'backbone'
import $ from 'jquery'

/* Exemplo Backbone */

export default class CTab extends Backbone.View {
    events () {
        this.Events = {
            'click a': 'changeTab'
        }
        return this.Events
    }

    initialize (options) {
        this.group = this.$el.data('group')
        this.links = this.$el.find('a')
        this.containers = $(`[data-container-group='${this.group}']`)
    }

    changeTab (ev) {
        const target = $(ev.target)
        const container = target.data('container')

        // verifica se todos os containers foram montados
        this.checkContainers()

        // Altera todos para inativo
        this.containers.hide().removeClass('active')
        this.links.removeClass('active')

        $(`#${container}`).show()
        $(`#${container}`).addClass('active')
        target.addClass('active')
    }

    checkContainers () {
        if (this.containers.length === 0) {
            this.group = this.$el.data('group')
            this.links = this.$el.find('a')
            this.containers = $(`[data-container-group='${this.group}']`)
        }
    }
}
